/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RankingOutputRanking model module.
 * @module model/RankingOutputRanking
 * @version 1.0
 */
class RankingOutputRanking {
    /**
     * Constructs a new <code>RankingOutputRanking</code>.
     * @alias module:model/RankingOutputRanking
     */
    constructor() { 
        
        RankingOutputRanking.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RankingOutputRanking</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RankingOutputRanking} obj Optional instance to populate.
     * @return {module:model/RankingOutputRanking} The populated <code>RankingOutputRanking</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RankingOutputRanking();

            if (data.hasOwnProperty('ranking')) {
                obj['ranking'] = ApiClient.convertToType(data['ranking'], Object);
            }
        }
        return obj;
    }


}

/**
 * @member {Object} ranking
 */
RankingOutputRanking.prototype['ranking'] = undefined;






export default RankingOutputRanking;

